const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the email template component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('emailTemplate', [function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        contentType: '=',
        content: '='
      },
      template: require('../../../templates/directives/messaging/email-template.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        if (!$scope.content.messaging || !$scope.content.messaging.email) {
          $scope.content.messaging.email = [];
        }

        self.config = {
          fields: ['from_name', 'subject', 'body'],
          from_name: '',
          subject: '',
          body: '',
          setFields: function() {
            self.config.fields.forEach(function(item) {
              for (var i = 0; i < $scope.content.messaging.email.length; i++) {
                if ($scope.content.messaging.email[i].name && $scope.content.messaging.email[i].name === item) {
                  self.config[item] = $scope.content.messaging.email[i].value;
                  return;
                }
              }
              $scope.content.messaging.email.push({name: item, value: ''});
              self.config[item] = '';
            });
          },
          toolbarAdditions: []
        };

        self.config.setFields();

        self.updateContent = function() {
          self.config.fields.forEach(function(item) {
            for (var i = 0; i < $scope.content.messaging.email.length; i++) {
              if ($scope.content.messaging.email[i].name && $scope.content.messaging.email[i].name === item) {
                $scope.content.messaging.email[i].value = self.config[item];
                return;
              }
            }
            $scope.content.messaging.email.push({name: item, value: self.config[item]});
          });
        };

        $scope.$watch('email.config.body', function(newVal, oldVal) {
          self.updateContent();
        });

        if ($scope.contentType === 'Workshop') {
          self.config.toolbarAdditions.push('workshop_options');
        }
        if ($scope.contentType === 'assignment') {
          self.config.toolbarAdditions.push('assignment_options');
        }

        self.applyFroalaConfigs = function(FroalaEditor) {
          // Define toolbar options
          if ($scope.contentType === 'Workshop') {
            FroalaEditor.DefineIcon('workshopDropIcon', {NAME: 'shoptag', template: 'continu_froala_replacement'});
            FroalaEditor.RegisterCommand('workshop_options', {
              title: 'Workshop Options',
              type: 'dropdown',
              icon: 'workshopDropIcon',
              focus: false,
              undo: false,
              refreshAfterCallback: true,
              options: {
                'recipient_first_name': 'Recipient First Name',
                'recipient_last_name': 'Recipient Last Name',
                'sender_first_name': 'Sender First Name',
                'sender_last_name': 'Sender Last Name',
                'workshop_title': 'Workshop Title',
                'workshop_start_date': 'Workshop Start Date',
                'workshop_start_time': 'Workshop Start Time',
                'workshop_end_date': 'Workshop End Date',
                'workshop_end_time': 'Workshop End Time',
                'workshop_location': 'Workshop Location',
                'host_name': 'Host Name'
              },
              callback: function (cmd, val) {
                this.html.insert('{' + val + '}');
              }
            });
          }
          // Define toolbar options
          if ($scope.contentType === 'assignment') {
            var options = {
              due_in: 'Due from now in Days',
              days_overdue: 'Days Overdue',
              assigned_content: 'Assigned Content List',
              assigner_first_name: 'Assigner First Name',
              assigner_last_name: 'Assigner Last Name',
              assignee_first_name: 'Assignee First Name',
              assignee_last_name: 'Assignee Last Name',
              recipient_first_name: 'Recipient First Name',
              recipient_last_name: 'Recipient Last Name'
            };

            FroalaEditor.DefineIcon('assignmentDropIcon', {NAME: 'shoptag', template: 'continu_froala_replacement'});
            FroalaEditor.RegisterCommand('assignment_options', {
              title: 'Assignment Options',
              type: 'dropdown',
              icon: 'assignmentDropIcon',
              focus: false,
              undo: false,
              refreshAfterCallback: true,
              options: options,
              callback: function (cmd, val) {
                this.html.insert('{' + val + '}');
              }
            });
          }
        };

      }],
      controllerAs: 'email'
    };
  }]);